import { json, error } from "@sveltejs/kit";
import { Octokit } from "@octokit/rest";
import { G as GITHUB_API_KEY } from "../../../../../../chunks/private.js";
import { i as isDevelopment } from "../../../../../../chunks/utils2.js";
const GET = async () => {
  const api = new Octokit({
    auth: GITHUB_API_KEY
  });
  try {
    const response = await api.rest.repos.listReleases({
      owner: "carlelieser",
      repo: "glimmr"
    });
    if (isDevelopment) return json(response.data.shift());
    const release = response.data.find((release2) => !release2.draft && !release2.prerelease);
    return json(release);
  } catch (err) {
    return error(500, {
      message: "Failed to get latest release."
    });
  }
};
export {
  GET
};
